import React from 'react'

export const Loading = () => {
  return (
    <div className='loadingContainer'>
        <div className='loader'>
            <div></div>
        </div>
    </div>
  )
}
